import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withBreakpoints } from 'react-breakpoints';
import { css } from '@emotion/core';
import DiscoverySectionInfo from '../DiscoverySectionInfo';
import { DiscoverSection } from '../common/FlexStyle';
import DiscoverInputs from '../DiscoverInputs';

const MobileSectionInfo = ({ qNumber, messageId, formatMessage }) => (
  <div
    css={css`
      position: absolute;
      height: 40px;
      margin-top: 30px;
      margin-left: 10px;
      font-family: Heebo-Thin;
      font-size: 22px;
      font-weight: 100;
      font-style: normal;
      font-stretch: normal;
      line-height: 0.21;
      letter-spacing: normal;
      text-align: left;
      color: #233b69;
    `}
  >
    <span
      css={css`
        font-size: 30px;
        font-weight: bold;
      `}
    >
      {qNumber ? `${qNumber}. ` : ''}
    </span>
    {messageId
      ? formatMessage({ id: messageId })
      : formatMessage({ id: 'discover.selectYourDiscoveryMethod' }) || ''}
  </div>
);

const DiscoveryInputsWrapper = props => {
  const {
    isDisabled,
    afterChange,
    qNumber,
    browserHistory,
    discoveryStore,
    formatMessage,
    buttonContent,
    messageId,
  } = props;

  const { breakpoints, currentBreakpoint } = props;

  return (
    <DiscoverSection isDisabled={isDisabled}>
      {breakpoints[currentBreakpoint] >= breakpoints.tablet && (
        <DiscoverySectionInfo
          isDisabledByStep={isDisabled}
          qNumber={qNumber}
          content={
            messageId
              ? formatMessage({ id: messageId })
              : formatMessage({ id: 'discover.selectYourDiscoveryMethod' })
          }
        />
      )}
      {breakpoints[currentBreakpoint] < breakpoints.tablet && !isDisabled && (
        <MobileSectionInfo qNumber={qNumber} messageId={messageId} formatMessage={formatMessage} />
      )}
      <DiscoverInputs
        afterChange={afterChange}
        browserHistory={browserHistory}
        setDiscoverMethod={discoveryStore.setDiscoverMethod}
        discoveryMethod={discoveryStore.discoverMethod}
        discoverValueString={discoveryStore.discoverValueString}
        setDiscoverValue={discoveryStore.setDiscoverValue}
        discoverValue={discoveryStore.discoverValue}
        setDiscoverValueString={discoveryStore.setDiscoverValueString}
        discoverSourceId={discoveryStore.discoverMarket}
        isDisabled={isDisabled}
        isWithVariations={discoveryStore.isWithVariations}
        automaticallyListItems={discoveryStore.automaticallyListItems}
        setAutomaticallyListItems={discoveryStore.setAutomaticallyListItems}
        setIsWithVariations={discoveryStore.setIsWithVariations}
        skipVeroValidation={discoveryStore.skipVeroValidation}
        setSkipVeroValidation={discoveryStore.setSkipVeroValidation}
        buttonContent={buttonContent}
        useCollageImage={discoveryStore.useCollageImage}
        setUseCollageImage={discoveryStore.setUseCollageImage}
        rotateImage={discoveryStore.rotateImage}
        setRotateImage={discoveryStore.setRotateImage}
        skipOptimization={discoveryStore.skipOptimization}
        setSkipOptimization={discoveryStore.setSkipOptimization}
        // value={discoveryStore.getDiscoverValue}
      />
    </DiscoverSection>
  );
};

DiscoveryInputsWrapper.propTypes = {
  discoveryStore: PropTypes.object,
  browserHistory: PropTypes.object,
  isDisabled: PropTypes.bool,
  formatMessage: PropTypes.func,
  afterChange: PropTypes.func,
  qNumber: PropTypes.number,
  buttonContent: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.node]),
  messageId: PropTypes.string,
};

export default withBreakpoints(observer(DiscoveryInputsWrapper));
